import { TADesktop } from "./TADesktop";

function TeachingDesktop() {
  return (
    <section id="teaching" className="pt-[80px] mb-[60px]">
      <div className="container items-start flex flex-col">
        <div className="flex flex-row items-center">
          <p className="text-[24px] font-medium mb-8">Teaching</p>
        </div>

        <div className="flex flex-col ">
          <TADesktop />
        </div>
      </div>
    </section>
  );
}

export default TeachingDesktop;
